import http from "./http-common"

export type FeatureFlag = {
    id: number
    name: string
    enabled: boolean
    rollout_percentage: number
    description: string | null
    overrides_count?: number
    created_at: string
    updated_at: string
}

export type FeatureFlagOverride = {
    userId: number
    userName: string
    userEmail: string
    enabled: boolean
    createdAt: string
}

export type FeatureFlagDetail = FeatureFlag & {
    overrides: FeatureFlagOverride[]
}

export type CreateFeatureFlagInput = {
    name: string
    enabled: boolean
    rolloutPercentage: number
    description: string | null
}

export type UpdateFeatureFlagInput = {
    enabled?: boolean
    rolloutPercentage?: number
    description?: string | null
}

const baseURL = "/admin/feature-flags"

export const listFeatureFlags = () =>
    http.get<FeatureFlag[]>(baseURL)

export const getFeatureFlagDetail = (name: string) =>
    http.get<FeatureFlagDetail>(`${baseURL}/${encodeURIComponent(name)}`)

export const createFeatureFlag = (input: CreateFeatureFlagInput) =>
    http.post<FeatureFlag>(baseURL, input)

export const updateFeatureFlag = (name: string, input: UpdateFeatureFlagInput) =>
    http.patch<FeatureFlag>(`${baseURL}/${encodeURIComponent(name)}`, input)

export const addFeatureFlagUserOverride = (
    name: string,
    userId: number,
    enabled: boolean
) =>
    http.post(`${baseURL}/${encodeURIComponent(name)}/users`, { userId, enabled })

export const removeFeatureFlagUserOverride = (name: string, userId: number) =>
    http.delete(`${baseURL}/${encodeURIComponent(name)}/users/${userId}`)